<template lang="pug">
div
  .card.small-space(v-if="rentObject")
    .top
      .left
        .card-headline {{rentObject.name}}
        .card-description {{rentObject.shortDescription}}
  b-dropdown(aria-role='list' @input="updateValue" :scrollable="true" :max-height="200")
    template(#trigger='{ active }')
      b-button(label='Auswahl' type='is-flat' icon-left="chevron-down")
    b-dropdown-item(v-for="rentObject in rentObjects.filter(r => r.rentObjectType.isBookable)" :focusable="false" aria-role='listitem' :value="rentObject.id") {{rentObject.name}}
</template>

<script>
export default {
  components: {
    
  },
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            id: null
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
      rentObject: null,
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    }
  },
  methods: {
    async updateValue(e) {
      this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: e });
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          id: e
        }
      });
    }
  },
  async mounted() {
    if (this.initBlock.value && this.initBlock.value.id) {
      this.rentObject = await this.$store.dispatch("rentObjects/findOne", { id: this.initBlock.value.id });
    }
    this.$store.dispatch("rentObjects/findAll");
  }
}
</script>

<style lang="scss" scoped>
.small-space {
  margin-bottom: 12px;
}
</style>